<div class="menu-bar">
  <!-- <ejs-menu #menu id='menu' [items]="menuItems">
    <ng-template #itemTemplate let-item>
      <a [routerLink]="item.path">{{ item.text }}</a>
    </ng-template>
  </ejs-menu> -->
  <ejs-menu #menu id='menu' [items]='menuItems'>
    <ng-template #template let-menuItems="">
          <a style="display:block" [routerLink]="menuItems.path">
              {{ menuItems.text }}
          </a>
     </ng-template>
  </ejs-menu>
</div>

